export let ProfessionalSituation = /*#__PURE__*/function (ProfessionalSituation) {
  ProfessionalSituation["Jobseeker"] = "jobseeker";
  ProfessionalSituation["JobseekerMutuality"] = "jobseeker_mutuality";
  ProfessionalSituation["CpasJobseeker"] = "cpas_jobseeker";
  return ProfessionalSituation;
}({});